import "./Navbar.scss"
import { Box, AppBar, Toolbar, IconButton, Typography, Menu, MenuItem, Button } from "@mui/material"
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react'
import { INavbarPage } from "../../models/navbar_models";
import { useNavigate } from "react-router-dom";
import * as components from "../"

interface INavbarProps {
  name?: string,
  pages?: Array<INavbarPage>
}

const Navbar = (props: INavbarProps) => {
  
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  const [showSettings, setShowSettings] = useState(false)

  const handleCloseNavMenu = (page?: INavbarPage ) => {
    setAnchorElNav(null)
    if(page){
      navigateToPage(`/${page.url}`)
    }
  };

  const navigateToPage = (page_url: string) => {
    navigate(page_url)
  }

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleShowSettingsChange = () => {
    setShowSettings(!showSettings)
  }

    return (
        <Box sx={{ flexGrow: 1 }}>
          <AppBar 
              position="static" 
              className="top-nav"
              sx={{
                border: `1px solid`, 
                backgroundColor: "background.default",
                borderColor: 'custom.border'
              }}
          >
            <Toolbar className="nav-toolbar">
              <IconButton
                size="large"
                edge="start"
                aria-label="menu"
                sx={{ mr: 2 }}
              >
              </IconButton>
              <Typography 
                variant="h6" 
                component="div"  
                sx={{ verticalAlign: "middle", cursor: "pointer", marginRight: "10px", color: "text.primary"}} 
                onClick={() => navigateToPage("/")}
              >
                {props.name || ""}
              </Typography>
              {/* Regular Navbar Links */}
              <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                {props.pages?.map((page, idx) => (
                  <Button
                    key={idx}
                    onClick={() => handleCloseNavMenu(page)}
                    sx={{ my: 2, color: 'text.primary', display: 'block'}}
                  >
                    {page.title}
                  </Button>
                ))}
                {/* Settings button at end */}
                <Box sx={{ display: "flex", flexGrow: 1, justifyContent: "flex-end", alignContent: "center"}}>
                  <components.Settings showSettings={showSettings} showSettingsClicked={handleShowSettingsChange}/>
                </Box>
              </Box>
              {/* Code for burger menu */}
              <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, justifyContent: "flex-end" }}>
                <IconButton
                  size="large"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                >
                  <MenuIcon sx={{ color: "text.primary"}}/>
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={() => handleCloseNavMenu()}
                  sx={{ display: { xs: 'block', md: 'none' } }}
                >
                  {props.pages?.map((page, idx) => (
                    <MenuItem key={idx} onClick={() => handleCloseNavMenu(page)}>
                      <Typography sx={{ textAlign: 'center' }}>{page.title}</Typography>
                    </MenuItem>
                  ))}
                  <MenuItem onClick={handleShowSettingsChange}>
                    <Typography sx={{ textAlign: 'center' }}>Settings</Typography>
                  </MenuItem>
                </Menu>
              </Box>
            </Toolbar>
        </AppBar>
      </Box>
    )
}

export default Navbar